import { CommonService } from './../../../../shared/services/common.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { IServiceBook } from './../../../../_models/profile-sections/IServiceBook';
import { IProfile } from './../../../../_models/account/IProfile';
import { ProfileService } from './../../../../shared/services/profile.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISetting } from 'src/app/_models/cms/ISetting';
import { SettingService } from 'src/app/shared/services/setting.service';

@Component({
  selector: 'app-employee-profile-list',
  templateUrl: './employee-profile-list.component.html'
})
export class EmployeeProfileListComponent implements OnInit {
  
  loading: boolean = true;
  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };
  profileLogs:any; 
  school: any;
  designation: any;
  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,  
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    designationId: '',
    stateId: '',
    districtId: '',
    schoolId: '',
    shalaId: '',
    male: '',
    female: '',
    isDisplaced: '',
    isSingleWomen: '',
    isSpouseIn: '',
    isTotalEmployee: '',
    financialYearId: ''
  };

  columns = [
    { title: 'Sr.No.', key: 'UserId', isSortable: false },
    { title: 'Name', key: 'FirstName', isSortable: false },
    { title: 'Designation', key: 'UserId', isSortable: false },
    { title: 'School/Place', key: 'UserId', isSortable: false },
    { title: 'RO Status', key: 'BirthDate', isSortable: false },
    {}
  ];

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];
  financialYears: IKeyValuePair[];
  setting: ISetting;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: ProfileService,
    private commonService: CommonService,
    private settingService: SettingService) {
  }

  ngOnInit() {
    this.settingService.getSetting().then(data => {
      this.setting = data;
      this.query.financialYearId = this.setting?.financialYearId;
    });
    this.bindDropDown();
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.regionId = params.regionId ? params.regionId : '';
        this.query.stateId = params.stateId ? params.stateId : '';
        this.query.districtId = params.districtId ? params.districtId : '';
        this.query.schoolId = params.schoolId ? params.schoolId : '';
        this.query.shalaId = params.shalaId ? params.shalaId : '';
        this.query.male = params.male ? params.male : '';
        this.query.female = params.female ? params.female : '';
        this.query.isSingleWomen = params.isSingleWomen ? params.isSingleWomen : '';
        this.query.isSpouseIn = params.isSpouseIn ? params.isSpouseIn : '';
        this.query.isTotalEmployee = params.isTotalEmployee ? params.isTotalEmployee : '';
        this.query.financialYearId = params.financialYearId ? params.financialYearId : this.setting?.financialYearId;
        const relativeUrl = this.router.url;
        localStorage.setItem('relativeUrl', relativeUrl);
  
  
        if (this.setting?.financialYearId == this.query.financialYearId) {
          this.populateProfiles();
        } else {
          this.populateProfilesLog();
        }
        this.bindCascadeDropdown();
      });
  }

  private populateProfiles() {
    this.loading = true;
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      }, (err) => console.log(err),
        () => this.loading = false);
  }
  private populateProfilesLog() {
    this.loading = true;   
    this.service.getprofileLog(this.query)
      .subscribe((response: IPaged) => {
        if (response) {      
          this.queryResult = response;
          this.profileLogs = this.queryResult.items.map(item => item.profileLog); 
          this.school = this.queryResult.items.map(item => item.school);
          this.designation = this.queryResult.items.map(item => item.designation);
        }
      }, (err) => console.log(err),
        () => this.loading = false);     
  }

  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
    this.commonService.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;
      }
    });
  }

  bindCascadeDropdown() {
    if (this.query.regionId) {
      this.getStates(this.query.regionId);
    }
    if (this.query.stateId) {
      this.getDistricts(this.query.stateId);
    }
    if (this.query.districtId) {
      this.getSchools(this.query.districtId);
    }
  }


  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number) {
    this.commonService.getSchools(districtId, 1).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/admin/employee-profile'], {
      queryParams: this.query
    });
  }
  onYearChange(financialYearId: string) {
    this.query.financialYearId = financialYearId;
  
    // Check if the selected financial year is "0", which means "All Years"
    if (financialYearId === '0') {
      this.query.financialYearId = 0; 
    } else {
      this.query.financialYearId = financialYearId;
    }
  }
  filter() {
    this.query.page = 1;

    const queryParams: any = { ...this.query };

    if (this.query.financialYearId === '0') {
      this.query.financialYearId = 0;
    } else { 
      this.query.financialYearId;
    }

    this.router.navigate(['/admin/employee-profile'], {
      queryParams: this.query
    });
  }

  getServiceBook(v: IServiceBook[]) {
    return v ? v.find(x => x.isPresent == true) : null;
  }

}
